export const DATA_VIZ_COLORS = [
	'#898cff ',
	'#90d4f7',
	'#71e096',
	'#fcdc89',
	'#f5a26e',
	'#f589b6',
	'#668de5',
	'#ed6d79',
	'#5ad0e5',
	'#cff381',
	'#f696e3',
	'#bb96ff',
	'#67eebd',
]
